import { render, staticRenderFns } from "./MobileMenuHeader.vue?vue&type=template&id=08d6b1c1&scoped=true"
import script from "./MobileMenuHeader.vue?vue&type=script&lang=js"
export * from "./MobileMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./MobileMenuHeader.vue?vue&type=style&index=0&id=08d6b1c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d6b1c1",
  null
  
)

export default component.exports